/* ============================================================
   Schlafzauber — Design-Zip 1:1 Portierung (Interaktivität)
   Portiert aus dem DCLogic-Framework der Design-Vorlage:
   3D-Bewertungs-Karussell, FAQ-Akkordeon, Duft/Größen-Picker
   (inkl. Lock-Regel), Chroma-Farbwechsel, Add-to-Cart + Toast.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function showToast() {
    var toast = document.querySelector('[data-sz-toast]');
    if (!toast) return;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  /* ---------- Warenkorb ---------- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sz-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
      })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    if (!variantId) {
      // Platzhalter-Modus (kein Produkt verknüpft): nur Toast wie im Design
      showToast();
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        // Direkt zum Warenkorb — kürzeste Strecke zur Kasse (auf /cart nur neu laden)
        if (window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        // Fallback: klassisches Formular-Verhalten
        window.location.href = '/cart/add?id=' + variantId + '&quantity=' + (quantity || 1);
      });
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-sz-atc]');
    if (!atc) return;
    e.preventDefault();
    var scope = atc.closest('section') || document;
    var pack = scope.querySelector('[data-sz-pack].is-active');
    var qty = pack ? parseInt(pack.getAttribute('data-sz-pack'), 10) || 1 : 1;
    addToCart(atc.getAttribute('data-variant-id'), qty);
  });

  /* ---------- Doppelpack-Auswahl (1 Kissen / 2 Kissen −15 %) ---------- */
  document.addEventListener('click', function (e) {
    var pack = e.target.closest('[data-sz-pack]');
    if (!pack) return;
    var scope = pack.closest('section') || document;
    scope.querySelectorAll('[data-sz-pack]').forEach(function (p) {
      p.classList.toggle('is-active', p === pack);
    });
    var note = scope.querySelector('[data-sz-pack-note]');
    if (note) note.toggleAttribute('hidden', pack.getAttribute('data-sz-pack') !== '2');
    var label = pack.getAttribute('data-atc-label');
    if (label) {
      var mainAtc = scope.querySelector('button[data-sz-atc]:not([data-sz-sticky])');
      if (mainAtc && mainAtc.textContent.indexOf('In den Warenkorb') === 0) mainAtc.textContent = label;
    }
  });

  /* ---------- FAQ-Akkordeon ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.sz-faq-toggle');
    if (!toggle) return;
    var item = toggle.closest('.sz-faq-item');
    var list = toggle.closest('[data-sz-faq]');
    if (!item || !list) return;
    var wasOpen = item.classList.contains('is-open');
    list.querySelectorAll('.sz-faq-item.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    if (!wasOpen) item.classList.add('is-open');
  });

  /* ---------- Duft/Größen-Picker (Klassiker) ---------- */
  function initKlassiker(root) {
    var variants = [];
    var dataEl = root.querySelector('[data-sz-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (err) { variants = []; }
    }
    var scentBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sz-scent]'));
    var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sz-size]'));
    var scentLabel = root.querySelector('[data-sz-scent-label]');
    var sizeLabel = root.querySelector('[data-sz-size-label]');
    var sizeInfo = root.querySelector('[data-sz-size-info]');
    var lockNote = root.querySelector('[data-sz-lock-note]');
    var atcBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sz-atc]'));

    var state = {
      scent: (root.getAttribute('data-default-scent') || 'Neutral'),
      size: (root.getAttribute('data-default-size') || 'M'),
      media: null
    };
    var galleryThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sz-thumb]'));
    // Bilder, die zu Größe S gehören (Varianten-Bild von S) — bei S nur diese zeigen, sonst ausblenden
    var sMedia = {};
    variants.forEach(function (v) {
      if (v.groesse === 'S' && v.media != null) sMedia[v.media] = true;
    });
    var hasSMedia = Object.keys(sMedia).length > 0;

    function variantFor(scent, size) {
      return variants.find(function (v) { return v.duft === scent && v.groesse === size; });
    }

    function sizeAllowed(scent, size) {
      if (variants.length) {
        var v = variantFor(scent, size);
        return !!(v && v.available);
      }
      // Platzhalter-Regel aus dem Design: Duft-Varianten nur in Größe M
      return scent === 'Neutral' || size === 'M';
    }

    function render() {
      var locked = state.scent !== 'Neutral';
      scentBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-sz-scent') === state.scent);
      });
      sizeBtns.forEach(function (b) {
        var k = b.getAttribute('data-sz-size');
        b.classList.toggle('is-active', k === state.size);
        b.classList.toggle('is-disabled', !sizeAllowed(state.scent, k));
      });
      if (scentLabel) scentLabel.textContent = state.scent;
      if (sizeLabel) sizeLabel.textContent = state.size;
      if (sizeInfo) {
        var activeBtn = sizeBtns.find(function (b) { return b.getAttribute('data-sz-size') === state.size; });
        if (activeBtn && activeBtn.getAttribute('data-info')) sizeInfo.textContent = activeBtn.getAttribute('data-info');
      }
      if (lockNote) lockNote.toggleAttribute('hidden', !locked);
      var v = variantFor(state.scent, state.size);
      // Galerie folgt der Variante: bei S nur die S-Bilder (weiß), sonst nur die übrigen
      if (galleryThumbs.length && v) {
        if (hasSMedia) {
          var isS = state.size === 'S';
          galleryThumbs.forEach(function (t, i) {
            t.hidden = isS ? !sMedia[i] : !!sMedia[i];
          });
        }
        var target = v.media != null ? v.media : 0;
        if (target !== state.media && galleryThumbs[target]) {
          galleryThumbs[target].click();
          state.media = target;
        }
      }
      atcBtns.forEach(function (b) {
        if (v) {
          b.setAttribute('data-variant-id', v.id);
        } else if (variants.length) {
          b.removeAttribute('data-variant-id');
        }
      });
    }

    scentBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.scent = b.getAttribute('data-sz-scent');
        if (!sizeAllowed(state.scent, state.size)) state.size = 'M';
        render();
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.size = b.getAttribute('data-sz-size');
        render();
      });
    });
    render();
  }

  /* ---------- Farbwechsel (Chroma-Therapie) ---------- */
  function initChroma(root) {
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-sz-color]'));
    var img = root.querySelector('[data-sz-chroma-img]');
    var label = root.querySelector('[data-sz-color-label]');
    var atcBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sz-atc]'));
    var farbItems = Array.prototype.slice.call(root.querySelectorAll('[data-sz-farbe]'));

    var colorInfo = root.querySelector('[data-sz-color-info]');
    function activate(swatch) {
      swatches.forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
      if (label) label.textContent = swatch.getAttribute('data-sz-color');
      if (colorInfo) colorInfo.textContent = swatch.getAttribute('data-info') || '';
      farbItems.forEach(function (it) {
        it.hidden = it.getAttribute('data-sz-farbe') !== swatch.getAttribute('data-sz-color');
      });
      if (img && swatch.getAttribute('data-image')) {
        var src = swatch.getAttribute('data-image');
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      }
      atcBtns.forEach(function (b) {
        var vid = swatch.getAttribute('data-variant-id');
        if (vid) {
          b.setAttribute('data-variant-id', vid);
        }
      });
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () { activate(s); });
    });
    var initial = swatches.find(function (s) { return s.classList.contains('is-active'); }) || swatches[0];
    if (initial) activate(initial);
  }

  /* ---------- 3D-Bewertungs-Karussell ---------- */
  function initCarousel(root) {
    var ring = root.querySelector('[data-sz-ring]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.sz-card'));
    var stage = root.querySelector('[data-sz-stage]');
    var prevBtn = root.querySelector('[data-sz-prev]');
    var nextBtn = root.querySelector('[data-sz-next]');
    var n = cards.length;
    if (!ring || !n) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var secPerCard = parseFloat(root.getAttribute('data-speed')) || 7;
    var phase = 0, extra = 0, extraTarget = 0, vel = 1, speedTarget = 1, lastTs = null, raf = null;
    var step = 2 * Math.PI / n;
    var radius = 0;

    function setupLayout() {
      // Kartenbreite aus dem DOM messen (offsetWidth ignoriert Transforms) —
      // so greifen die Mobile-Breiten aus sz-theme.css automatisch.
      var cardW = cards[0].offsetWidth || Math.min(320, (window.innerWidth || 1200) * 0.76);
      radius = ((cardW + 18) * n) / (2 * Math.PI);
      cards.forEach(function (el, i) {
        el.style.transform = 'translate(-50%,-50%) rotateY(' + (i * step).toFixed(5) + 'rad) translateZ(' + radius.toFixed(1) + 'px)';
      });
    }

    function applyFrame() {
      var ph = phase + extra;
      ring.style.transform = 'rotateY(' + (-ph).toFixed(5) + 'rad)';
      cards.forEach(function (el, i) {
        var dn = (Math.cos(i * step - ph) + 1) / 2;
        el.style.opacity = (0.3 + 0.7 * dn).toFixed(3);
      });
    }

    function loop(ts) {
      var last = lastTs === null ? ts : lastTs;
      var dt = Math.min((ts - last) / 1000, 0.05);
      lastTs = ts;
      vel += (speedTarget - vel) * Math.min(1, dt * 3);
      phase += (2 * Math.PI / (secPerCard * n)) * dt * vel;
      extra += (extraTarget - extra) * Math.min(1, dt * 6);
      applyFrame();
      raf = requestAnimationFrame(loop);
    }

    function nudge(dir) {
      extraTarget += dir * step;
      if (reduced) {
        extra = extraTarget;
        applyFrame();
      }
    }

    setupLayout();
    applyFrame();
    window.addEventListener('resize', setupLayout);
    if (!reduced) raf = requestAnimationFrame(loop);
    if (stage) {
      stage.addEventListener('mouseenter', function () { speedTarget = 0; });
      stage.addEventListener('mouseleave', function () { speedTarget = 1; });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { nudge(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { nudge(1); });
  }

  /* ---------- Init ---------- */
  function init() {
    document.querySelectorAll('[data-sz-klassiker]').forEach(initKlassiker);
    document.querySelectorAll('[data-sz-chroma]').forEach(initChroma);
    document.querySelectorAll('[data-sz-carousel]').forEach(initCarousel);
    updateCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme-Editor: Sections werden dynamisch neu geladen
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sz-klassiker]').forEach(initKlassiker);
    e.target.querySelectorAll('[data-sz-chroma]').forEach(initChroma);
    e.target.querySelectorAll('[data-sz-carousel]').forEach(initCarousel);
  });
})();
